import { combineReducers } from "redux";
import { ITooltipsDto } from "../../../features/globals/interface/dto/tooltips.dto";
import { IIGSEState } from "../../../shared/igse-redux/igse-state";
import {
    defaultEmailUpdateFrequency,
    defaultEmailUpdateTime,
} from "../const/email-updates";
import { DynamicLabelType } from "../enums/dynamic-labels";
import { DelimeterType } from "../enums/file-delimeter";
import { TerminatorType } from "../enums/line-terminator";
import { IUserPrefrencesDto } from "../interface/dto/user-preferences.dto";
import { tooltipsReducer } from ".";
import {
    IUserPreferencesActions,
    UserPreferencesActionTypes,
} from "./user-preferences.action";

export interface IUserPreferencesState {
    isLoading: boolean;
    error?: string;
    data: IUserPrefrencesDto;
}

const initUserPreferencesState: IUserPreferencesState = {
    isLoading: false,
    data: {
        saveFileWithExtension: true,
        fileNameFormat: `[${DynamicLabelType.ListName}][${DynamicLabelType.LastUpdated}]`,
        fileFormatDelimiter: DelimeterType.CommaDelimeter,
        fileFormatTerminator: TerminatorType.WindowsStyle,
        emailUpdateTrackedListsUpdates: false,
        emailUpdateFrequency: defaultEmailUpdateFrequency,
        emailUpdateTime: defaultEmailUpdateTime,
        displayHiddenColumns: false,
        allowCustomColumnOrder: false,
        availableDataFields: [],
        preferredDataFields: [],
    },
};

export const userPreferencesReducer = (
    state = initUserPreferencesState,
    action: IUserPreferencesActions,
): IUserPreferencesState => {
    switch (action.type) {
        case UserPreferencesActionTypes.USERPREFERENCES_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };
        case UserPreferencesActionTypes.USERPREFERENCES_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload,
            };
        case UserPreferencesActionTypes.USERPREFERENCES_GET_ERROR:
        case UserPreferencesActionTypes.USERPREFERENCES_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        case UserPreferencesActionTypes.USERPREFERENCES_UPDATE:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                data: action.payload.data,
            };
        case UserPreferencesActionTypes.USERPREFERENCES_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
};

export const userPreferencesPageReducer = combineReducers({
    page: userPreferencesReducer,
    tooltips: tooltipsReducer,
});

export interface IUserPreferencesPageState {
    page: IUserPreferencesState;
    tooltips: IIGSEState<Array<ITooltipsDto>>;
}
